import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup} from '@angular/forms';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-text-filter',
  templateUrl: './text-filter.component.html',
  styleUrls: ['./text-filter.component.css']
})
export class TextFilterComponent implements OnInit {

  @Output() searchString: EventEmitter<string|undefined> = new EventEmitter()
  @Input() reset: EventEmitter<void>
  searchForm: FormGroup
  value: string|undefined = undefined
  showLoading:boolean=false
  @Input() set loadingPagination( l: boolean) {
    this.showLoading = l
  }

  constructor(
    private formBuilder: FormBuilder
  ) {
    this.searchForm = this.formBuilder.group({
      searchString: []
    })
  }

  ngOnInit(): void {
    this.searchForm.controls.searchString.valueChanges.pipe(
      debounceTime(500)
    ).subscribe((str: string) => {
      if (!str) {
        this.value = undefined
        this.searchString.emit(undefined)
        return
      }
      const lower = str.toLowerCase()
      const trimmed = lower.trim()
      this.searchString.emit(trimmed)
      this.value = str
    })

    if (this.reset) this.reset.subscribe(() => {
      this.searchForm.reset(undefined, {emitEvent: false})
    })
  }

}
